export default{
  name: 'app'
}



// WEBPACK FOOTER //
// ./src/mv/app.js